import IAddress1UnitNoZipCode from '../common/IAddress1UnitNoZipCode';

export default interface IMlsImportStats {
    count: number;
    added: number;
    replaced: number;
    ignored: number;
    errors: number;
    included: IAddress1UnitNoZipCode[];
}

export function newMlsImportStats(): IMlsImportStats {
    const stats: IMlsImportStats = {
        count: 0,
        added: 0,
        replaced: 0,
        ignored: 0,
        errors: 0,
        included: []
    };
    return stats;
}
